__turbopack_context__.v({
  "contentContainer": "JReGyq_contentContainer",
  "ctaWrapper": "JReGyq_ctaWrapper",
  "faqLink": "JReGyq_faqLink",
  "heading": "JReGyq_heading",
  "imageWrapper": "JReGyq_imageWrapper",
  "productImage": "JReGyq_productImage",
  "section": "JReGyq_section",
});
